export const companyInfo = {
  name: 'GSL GLASOLUX GmbH',
  street: 'Fabrikstraße 24',
  postalCode: '33659',
  city: 'Bielefeld',
  phone: '+49 521 7701943-0',
  fax: '+49 (0) 521 7701 943-24',
  email: 'anfrage@glasolux.de',
  website: 'www.glasolux.de',
  vatId: 'DE 302 138 482',
  taxNumber: '349/5724/1634',
  ceo: 'Christian Hilbert',
  courtRegistry: 'Amtsgericht Bielefeld HRB 41895',
  // Bankverbindungen
  banking: {
    volksbank: {
      name: 'Volksbank Bielefeld-Gütersloh eG',
      iban: 'DE46 4786 0125 1430 2552 00',
      bic: 'GENODEM1GTL'
    },
    sparkasse: {
      name: 'Sparkasse Bielefeld',
      iban: 'DE17 4805 0161 0050 0833 10',
      bic: 'SPBIDE3BXXX'
    }
  },
  colors: {
    primary: '#77b829', // GLASOLUX Grün
    secondary: '#669b23', // Dunkleres Grün
    text: '#2c4c0f', // Sehr dunkles Grün
    lightText: '#98c95a', // Helles Grün
  }
}; 